import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-entry-voucher',
    templateUrl: './entry-voucher.component.html',
    styleUrls: ['./entry-voucher.component.scss'],
    standalone: false
})
export class EntryVoucherComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
